<template>
  <path fill="#FF0000" :style="{fill : $attrs.fgColor}"
        d="M36,11.8c-0.3-1.8-1.8-3.1-3.5-3.3C29.7,8,25.2,7.5,20,7.5S10.2,8,7.5,8.4C5.8,8.7,4.3,10,4,11.8
	c-0.3,1.9-0.7,4.8-0.7,8.2s0.3,6.3,0.7,8.2c0.3,1.8,1.8,3.1,3.5,3.3c2.8,0.4,7.4,0.9,12.5,0.9c5.2,0,9.8-0.5,12.5-0.9
	c1.8-0.2,3.2-1.6,3.5-3.3c0.3-1.9,0.7-4.8,0.8-8.2C36.8,16.5,36.3,13.7,36,11.8z M16.7,25.8V14.2l10,5.8L16.7,25.8z"/>

</template>

<script>
export default {
  name: "svgYoutube"
}
</script>

<style scoped>

</style>